import { ComboboxItem } from '@node-space/ui-components'
import { AllowedCountry, Country } from 'types/authentication/Profile'

export const getCountryOptions = (countries: AllowedCountry[] | Country[]): ComboboxItem[] =>
  countries?.map(({ name, code }) => ({
    leftText: name,
    value: code,
  }))

export const getFormObject = <
  FormKeyType extends string,
  MappedValue,
  Result = Record<FormKeyType, MappedValue>,
>(
  formKeys: FormKeyType[],
  mappingFn: (key: FormKeyType) => MappedValue
): Result => {
  return formKeys.reduce(
    (object, key) => {
      object[key] = mappingFn(key)
      return object
    },
    {} as Record<FormKeyType, MappedValue>
  ) as Result
}
